import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import LivePagesByLineLastUpdatedQuery, {
	type LivePagesByLineLastUpdatedQuery$data,
	type LivePagesByLineLastUpdatedQuery$variables,
} from './by-line/__generated__/LivePagesByLineLastUpdatedQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadLastUpdated(
	contentId: any,
	useCache: any,
): Promise<{
	data: LivePagesByLineLastUpdatedQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<LivePagesByLineLastUpdatedQuery$data, LivePagesByLineLastUpdatedQuery$variables>({
		query: LivePagesByLineLastUpdatedQuery,
		variables: {
			contentId,
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
}
